<template>
  <div class="nuttrema-list-search" :class="{ 'is-active': isActive, 'is-blur': isBlur }">

    <el-autocomplete
       class="w-100"
       v-model="search"
      :placeholder="$t(placeholder)"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      :debounce="500"
      @select="doSearch"
      @focusin="onFocusIn"
      @focusout="onFocusOut"
      @keyup.native.enter="doSearch">
        <template slot="prefix">
          <i class="el-icon-search el-input__icon" @click="doSearch" :title="$t('label.search')"></i>
        </template>
        <template slot="suffix" v-if="isActive">
          <i class="el-icon-circle-close el-input__icon" :title="$t('label.clear')" @click="doClearSearch"></i>
        </template>
      </el-autocomplete>

  </div>
</template>

<script>
import Vue from 'vue';

import { isNil, isEmpty, find } from 'lodash';
import { LocalStoreOptions } from 'services';

export default {
  name: 'list-search',
  props: {
    placeholder: {
      type: String, // String, Number, Boolean, Function, Object, Array
      required: false,
      default: 'label.search',
    },
    // livesearch: {
    //   type: Boolean,
    //   required: false,
    //   default: false,
    // },
    localStorageKey: {
      type: String,
      required: false,
      default: null,
    },
    historyLimit: {
      type: Number,
      required: false,
      default: 50,
    },
    query: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      search: '',
      timer: null,
      isBlur: false,
      storage: {
        history: [],
      },
    };
  },
  computed: {
    isActive() {
      return !isEmpty(this.search);
    },
    // isLiveSearch() {
    //   return this.search !== '' && this.livesearch;
    // },
    storageKey() {
      return this.localStorageKey ? `${this.localStorageKey}_index_search` : null;
    },
  },
  methods: {
    doClearSearch() {
      this.search = '';
      this.doSearch();
    },
    doSearch() {
      this.$emit('search', this.search);
      this.addSearchInHistory(this.storage.history, this.search);
    },
    onFocusIn() {
      this.isBlur = true;
    },
    onFocusOut() {
      this.isBlur = false;
    },
    querySearch(queryString, cb) {
      const history = this.storage.history;
      const results = queryString ? history.filter(this.createFilter(queryString)) : history;
      cb(results);
    },
    createFilter(queryString) {
      return link => link.value.toLowerCase() !== queryString.toLowerCase() && link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    },
    addSearchInHistory(history, search) {
      if (!isNil(search) && search !== '') {
        if (history.length >= this.historyLimit) {
          Vue.delete(history, 0);
        }

        const inHistory = find(history, item => item.value === search);

        if (!inHistory) {
          history.push({ value: search });
          this.saveHistory();
        }
      }
    },
    saveHistory() {
      if (this.storageKey) LocalStoreOptions.set(this.storageKey, this.storage);
    },
    loadHistory() {
      if (this.storageKey) LocalStoreOptions.get(this.storageKey, this.storage);
    },
  },
  mounted() {
    this.history = this.loadHistory();
    this.search = this.query;
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .nuttrema-list-search {

    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    flex-grow: 1;
    background-color: $index-search-inactive-bg;

    margin: 5px; padding: 0.25em;
    border-radius: 5px;

    /deep/ .el-autocomplete {
      .el-input__prefix, .el-input__suffix {
        i {
          color: #607d8b;
          &:hover, &:focus, &:active {
            cursor: pointer;
          }
        }
      }
    }

    &.is-blur {
      background-color: $index-search-inactive-bg;
    }

    &.is-active {
      background-color: $index-search-active-bg;
      .el-button--clear {
        display: block;
      }
    }

    &.is-livesearch {
      background-color: $index-search-active-bg;
      .nuttrema-list-search__buttons {
        visibility: hidden;
      }
    }

    &.is-active.is-livesearch {
      .nuttrema-list-search__buttons {
        visibility: visible;
        > .do-search {
          display: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/search/list-search.vue